module.exports = __webpack_public_path__ + "img/cyberboard_text.703c08bb.png";